(function () {
  'use strict';

  var selectors = {
    sellingSection: '[data-great-selling-section]',
    sellingViewport: '[data-great-selling-viewport]',
    sellingPrev: '[data-great-selling-prev]',
    sellingNext: '[data-great-selling-next]',
    sortSelect: '[data-great-sort-select]',
    filterForm: '.great-filters-form form',
    quickAddForm: '.great-card__form',
    mobileFilterToggle: '[data-great-filter-toggle]',
    mobileFilterPanel: '[data-great-filter-panel]',
    mobileFilterClose: '[data-great-filter-close]'
  };

  function isMobileFilters() {
    return window.matchMedia &&
      window.matchMedia('(max-width: 989px)').matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getCarouselAmount(scroller) {
    if (!scroller) return 260;

    var firstSlide = scroller.querySelector('.great-selling__slide');

    if (firstSlide) {
      var width = firstSlide.getBoundingClientRect().width;
      var computed = window.getComputedStyle(firstSlide);
      var marginRight = parseFloat(computed.marginRight) || 0;

      return width + marginRight + 12;
    }

    return Math.max(scroller.clientWidth * 0.85, 240);
  }

  function updateCarouselButtons(scroller, prevButton, nextButton) {
    if (!scroller) return;

    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    var atStart = scroller.scrollLeft <= 4;
    var atEnd = scroller.scrollLeft >= maxScroll - 4 || maxScroll <= 0;

    if (prevButton) {
      prevButton.disabled = atStart;
      prevButton.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    }

    if (nextButton) {
      nextButton.disabled = atEnd;
      nextButton.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
  }

  function scrollCarousel(scroller, direction) {
    if (!scroller) return;

    scroller.scrollBy({
      left: direction === 'prev' ? -getCarouselAmount(scroller) : getCarouselAmount(scroller),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  function initSellingCarousel(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll(selectors.sellingSection);

    sections.forEach(function (section) {
      if (section.dataset.greatSellingInit === 'true') return;

      var scroller = section.querySelector(selectors.sellingViewport);
      var prevButton = section.querySelector(selectors.sellingPrev);
      var nextButton = section.querySelector(selectors.sellingNext);

      if (!scroller) return;

      section.dataset.greatSellingInit = 'true';

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          scrollCarousel(scroller, 'prev');
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          scrollCarousel(scroller, 'next');
        });
      }

      scroller.addEventListener(
        'scroll',
        function () {
          window.requestAnimationFrame(function () {
            updateCarouselButtons(scroller, prevButton, nextButton);
          });
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        window.requestAnimationFrame(function () {
          updateCarouselButtons(scroller, prevButton, nextButton);
        });
      });

      updateCarouselButtons(scroller, prevButton, nextButton);
    });
  }

  function setMobileFilterState(toggle, panel, shouldOpen) {
    if (!toggle || !panel) return;

    toggle.classList.toggle('is-open', shouldOpen);
    panel.classList.toggle('is-open', shouldOpen);
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    if (shouldOpen && isMobileFilters()) {
      window.requestAnimationFrame(function () {
        var panelTop = panel.getBoundingClientRect().top + window.pageYOffset - 90;

        window.scrollTo({
          top: Math.max(panelTop, 0),
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      });
    }
  }

  function closeMobileFilterPanel(panel) {
    if (!panel) return;

    var panelId = panel.getAttribute('id');
    if (!panelId) return;

    var toggle = document.querySelector('[data-great-filter-toggle][aria-controls="' + panelId + '"]');

    setMobileFilterState(toggle, panel, false);
  }

  function closeNearestMobileFilterPanel(element) {
    if (!element) return;

    var panel = element.closest(selectors.mobileFilterPanel);

    if (panel) {
      closeMobileFilterPanel(panel);
    }
  }

  function initMobileFilterDropdown(scope) {
    var root = scope || document;
    var toggles = root.querySelectorAll(selectors.mobileFilterToggle);

    toggles.forEach(function (toggle) {
      if (toggle.dataset.greatMobileFilterInit === 'true') return;

      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;

      if (!panel) return;

      var closeButton = panel.querySelector(selectors.mobileFilterClose);
      var filterGroups = panel.querySelectorAll('.great-filter-group');

      toggle.dataset.greatMobileFilterInit = 'true';

      toggle.addEventListener('click', function () {
        var shouldOpen = !panel.classList.contains('is-open');

        setMobileFilterState(toggle, panel, shouldOpen);
      });

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          setMobileFilterState(toggle, panel, false);
        });
      }

      filterGroups.forEach(function (group) {
        if (isMobileFilters()) {
          group.removeAttribute('open');
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && panel.classList.contains('is-open')) {
          setMobileFilterState(toggle, panel, false);
        }
      });

      document.addEventListener('click', function (event) {
        if (!isMobileFilters()) return;
        if (!panel.classList.contains('is-open')) return;

        var clickedInsidePanel = panel.contains(event.target);
        var clickedToggle = toggle.contains(event.target);

        if (!clickedInsidePanel && !clickedToggle) {
          setMobileFilterState(toggle, panel, false);
        }
      });

      window.addEventListener('resize', function () {
        if (!isMobileFilters()) {
          setMobileFilterState(toggle, panel, false);
        }
      });
    });
  }

  function initSortForms(scope) {
    var root = scope || document;
    var selects = root.querySelectorAll(selectors.sortSelect);

    selects.forEach(function (select) {
      if (select.dataset.greatSortInit === 'true') return;

      select.dataset.greatSortInit = 'true';

      select.addEventListener('change', function () {
        if (!select.form) return;

        select.setAttribute('aria-busy', 'true');
        select.form.submit();
      });
    });
  }

  function initFilterForms(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll(selectors.filterForm);

    forms.forEach(function (form) {
      if (form.dataset.greatFilterInit === 'true') return;

      form.dataset.greatFilterInit = 'true';

      form.addEventListener('change', function (event) {
        var target = event.target;

        if (!target) return;

        if (target.matches('input[type="checkbox"], select')) {
          if (isMobileFilters()) {
            closeNearestMobileFilterPanel(form);
          }

          form.submit();
        }
      });

      form.addEventListener('submit', function () {
        var submitButton = form.querySelector('button[type="submit"]');

        if (submitButton) {
          submitButton.classList.add('loading');
          submitButton.setAttribute('aria-busy', 'true');
        }

        if (isMobileFilters()) {
          closeNearestMobileFilterPanel(form);
        }
      });
    });
  }

  function initQuickAddLoading(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll(selectors.quickAddForm);

    forms.forEach(function (form) {
      if (form.dataset.greatQuickAddInit === 'true') return;

      var button = form.querySelector('button[type="submit"]');

      if (!button) return;

      form.dataset.greatQuickAddInit = 'true';

      form.addEventListener('submit', function () {
        button.classList.add('loading');
        button.setAttribute('aria-busy', 'true');

        window.setTimeout(function () {
          button.classList.remove('loading');
          button.removeAttribute('aria-busy');
        }, 4000);
      });
    });
  }

  function initGreatDeals(scope) {
    initSellingCarousel(scope);
    initMobileFilterDropdown(scope);
    initSortForms(scope);
    initFilterForms(scope);
    initQuickAddLoading(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGreatDeals(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initGreatDeals(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    initGreatDeals(event.target);
  });
})();